import { connect } from 'react-redux';
import { requestAuthentication } from '../../actions/app';
import BankSelection from './BankSelection';

const mapStateToProps = state => ({
  createUserIfNotExists: state.session.createUserIfNotExists
});

const mapDispatchToProps = dispatch => ({
  requestAuthentication: dispatch(requestAuthentication)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BankSelection);




// WEBPACK FOOTER //
// ./src/components/BankSelection/index.js